module.exports = __webpack_public_path__ + "static/media/logo-usd.8b88ec03.svg";